import {
  cancelOrder,
  captureOrder,
  createSession,
  makeDecision,
  readSession,
  refundCapture,
  releaseRemaining,
  updateMetadata,
  updateOrderCart,
  updateOrderReferences,
  updateSession
} from './briqpayCheckoutEndpoints'

export const briqpayCheckoutApi = {
  createSession,
  readSession,
  updateSession,
  updateMetadata,
  makeDecision,
  cancelOrder,
  captureOrder,
  refundCapture,
  releaseRemaining,
  updateOrderCart,
  updateOrderReferences
}

export * from './utils'
